// extracted by mini-css-extract-plugin
export var mobileHidden = "Reviews-module--mobileHidden--7882b";
export var reviewsio_content = "Reviews-module--reviewsio_content--4bab6";
export var reviewsio_root = "Reviews-module--reviewsio_root--5dc54";
export var reviewsio_score = "Reviews-module--reviewsio_score--84a96";
export var reviewsio_star_bg = "Reviews-module--reviewsio_star_bg--bc1bf";
export var reviewsio_star_bg_container = "Reviews-module--reviewsio_star_bg_container--f4af6";
export var reviewsio_star_fe = "Reviews-module--reviewsio_star_fe--26383";
export var reviewsio_star_fe_container = "Reviews-module--reviewsio_star_fe_container--67520";
export var reviewsio_stars = "Reviews-module--reviewsio_stars--d4a2e";
export var reviewsio_text = "Reviews-module--reviewsio_text--65b3a";
export var trustpilot_link = "Reviews-module--trustpilot_link--2d971";
export var trustpilot_root = "Reviews-module--trustpilot_root--ba060";
export var trustpilot_score = "Reviews-module--trustpilot_score--d1ef8";
export var trustpilot_starBackground = "Reviews-module--trustpilot_starBackground--d2dea";
export var trustpilot_starContainer = "Reviews-module--trustpilot_starContainer--718a0";
export var trustpilot_starFill = "Reviews-module--trustpilot_starFill--6b542";
export var trustpilot_stars = "Reviews-module--trustpilot_stars--763f3";